const model = {
  groupName: '',
  isOwningGroup: false,
  memberOrgs: [],
  defaultOrg: null
}

export { model }



// WEBPACK FOOTER //
// ./src/api/models/group.js